// @generated by protobuf-ts 2.9.4 with parameter generate_dependencies,optimize_code_size
// @generated from protobuf file "core/v1/events.proto" (package "core.v1", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { Date } from "./date";
/**
 * Something that happens in the plan that isn't a money movement the household makes (those are
 * Actions). Facts only: the UI writes all wording (never "bankruptcy").
 *
 * @generated from protobuf message core.v1.Event
 */
export interface Event {
    /**
     * @generated from protobuf field: core.v1.Date date = 1;
     */
    date?: Date;
    /**
     * @generated from protobuf field: core.v1.Event.Type type = 2;
     */
    type: Event_Type;
    /**
     * @generated from protobuf field: core.v1.Event.Importance importance = 3;
     */
    importance: Event_Importance;
    /**
     * @generated from protobuf field: string member_uuid = 4;
     */
    memberUuid: string; // the person it concerns, if any
    /**
     * @generated from protobuf field: string entity_uuid = 5;
     */
    entityUuid: string; // the job, debt, account, priority, ... it concerns, if any
    /**
     * @generated from protobuf oneof: details
     */
    details: {
        oneofKind: "income";
        /**
         * @generated from protobuf field: core.v1.IncomeDetails income = 10;
         */
        income: IncomeDetails;
    } | {
        oneofKind: "priorityDue";
        /**
         * @generated from protobuf field: core.v1.PriorityDueDetails priority_due = 11;
         */
        priorityDue: PriorityDueDetails;
    } | {
        oneofKind: "taxYear";
        /**
         * @generated from protobuf field: core.v1.TaxYearDetails tax_year = 12;
         */
        taxYear: TaxYearDetails;
    } | {
        oneofKind: "shortfall";
        /**
         * @generated from protobuf field: core.v1.ShortfallDetails shortfall = 13;
         */
        shortfall: ShortfallDetails;
    } | {
        oneofKind: "retirement";
        /**
         * @generated from protobuf field: core.v1.RetirementDetails retirement = 14;
         */
        retirement: RetirementDetails;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf enum core.v1.Event.Type
 */
export enum Event_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * a paycheque or other income payment (IncomeDetails)
     *
     * @generated from protobuf enum value: TYPE_INCOME = 1;
     */
    INCOME = 1,
    /**
     * CESG, CLB (IncomeDetails)
     *
     * @generated from protobuf enum value: TYPE_GOVERNMENT_GRANT = 2;
     */
    GOVERNMENT_GRANT = 2,
    /**
     * a priority occurrence came due (PriorityDueDetails)
     *
     * @generated from protobuf enum value: TYPE_PRIORITY_DUE = 3;
     */
    PRIORITY_DUE = 3,
    /**
     * 31 Dec tax settlement (TaxYearDetails)
     *
     * @generated from protobuf enum value: TYPE_TAX_YEAR = 4;
     */
    TAX_YEAR = 4,
    /**
     * the money on hand doesn't cover what's due (ShortfallDetails)
     *
     * @generated from protobuf enum value: TYPE_CASH_SHORTFALL = 5;
     */
    CASH_SHORTFALL = 5,
    /**
     * @generated from protobuf enum value: TYPE_DEBT_PAID_OFF = 6;
     */
    DEBT_PAID_OFF = 6,
    /**
     * per member (RetirementDetails)
     *
     * @generated from protobuf enum value: TYPE_RETIREMENT = 7;
     */
    RETIREMENT = 7,
    /**
     * @generated from protobuf enum value: TYPE_PENSION_START = 8;
     */
    PENSION_START = 8,
    /**
     * CPP or OAS starts (IncomeDetails.source says which)
     *
     * @generated from protobuf enum value: TYPE_BENEFIT_START = 9;
     */
    BENEFIT_START = 9,
    /**
     * @generated from protobuf enum value: TYPE_JOB_ENDED = 10;
     */
    JOB_ENDED = 10,
    /**
     * @generated from protobuf enum value: TYPE_ACCOUNT_CREATED = 11;
     */
    ACCOUNT_CREATED = 11,
    /**
     * @generated from protobuf enum value: TYPE_MORTGAGE_REFINANCE = 12;
     */
    MORTGAGE_REFINANCE = 12,
    /**
     * @generated from protobuf enum value: TYPE_RRSP_TO_RRIF = 13;
     */
    RRSP_TO_RRIF = 13,
    /**
     * a priority reached its end with every occurrence fully funded (before engines that emit
     * TYPE_PRIORITY_MISSED, it fired at the end whether or not it was funded)
     *
     * @generated from protobuf enum value: TYPE_PRIORITY_COMPLETED = 14;
     */
    PRIORITY_COMPLETED = 14,
    /**
     * @generated from protobuf enum value: TYPE_EXPENSE_COMPLETED = 15;
     */
    EXPENSE_COMPLETED = 15,
    /**
     * @generated from protobuf enum value: TYPE_RESP_CLOSED = 16;
     */
    RESP_CLOSED = 16,
    /**
     * a priority reached its end with an occurrence not fully funded (PRIORITY_DUE received below
     * required), e.g. a home-buying goal whose purchase the plan skipped; instead of PRIORITY_COMPLETED
     *
     * @generated from protobuf enum value: TYPE_PRIORITY_MISSED = 17;
     */
    PRIORITY_MISSED = 17
}
/**
 * @generated from protobuf enum core.v1.Event.Importance
 */
export enum Event_Importance {
    /**
     * @generated from protobuf enum value: IMPORTANCE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: IMPORTANCE_MAJOR = 1;
     */
    MAJOR = 1,
    /**
     * @generated from protobuf enum value: IMPORTANCE_MINOR = 2;
     */
    MINOR = 2
}
/**
 * @generated from protobuf message core.v1.IncomeDetails
 */
export interface IncomeDetails {
    /**
     * @generated from protobuf field: core.v1.IncomeDetails.Source source = 1;
     */
    source: IncomeDetails_Source;
    /**
     * @generated from protobuf field: double gross = 2;
     */
    gross: number;
    /**
     * @generated from protobuf field: double deductions = 3;
     */
    deductions: number; // income tax withheld + CPP + EI + pension contributions
    /**
     * @generated from protobuf field: double net = 4;
     */
    net: number; // what lands in the account
    /**
     * @generated from protobuf field: string destination_account_uuid = 5;
     */
    destinationAccountUuid: string;
    /**
     * @generated from protobuf field: double group_rrsp_contribution = 6;
     */
    groupRrspContribution: number; // included in deductions
    /**
     * @generated from protobuf field: double group_rrsp_employer_match = 7;
     */
    groupRrspEmployerMatch: number;
}
/**
 * @generated from protobuf enum core.v1.IncomeDetails.Source
 */
export enum IncomeDetails_Source {
    /**
     * @generated from protobuf enum value: SOURCE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: SOURCE_JOB = 1;
     */
    JOB = 1,
    /**
     * UntaxedIncome
     *
     * @generated from protobuf enum value: SOURCE_OTHER_INCOME = 2;
     */
    OTHER_INCOME = 2,
    /**
     * @generated from protobuf enum value: SOURCE_CPP = 3;
     */
    CPP = 3,
    /**
     * @generated from protobuf enum value: SOURCE_OAS = 4;
     */
    OAS = 4,
    /**
     * @generated from protobuf enum value: SOURCE_DB_PENSION = 5;
     */
    DB_PENSION = 5,
    /**
     * @generated from protobuf enum value: SOURCE_DC_PENSION = 6;
     */
    DC_PENSION = 6,
    /**
     * @generated from protobuf enum value: SOURCE_RRIF = 7;
     */
    RRIF = 7,
    /**
     * @generated from protobuf enum value: SOURCE_CESG = 8;
     */
    CESG = 8,
    /**
     * @generated from protobuf enum value: SOURCE_CLB = 9;
     */
    CLB = 9,
    /**
     * @generated from protobuf enum value: SOURCE_TAX_REFUND = 10;
     */
    TAX_REFUND = 10
}
/**
 * @generated from protobuf message core.v1.PriorityDueDetails
 */
export interface PriorityDueDetails {
    /**
     * @generated from protobuf field: double required = 1;
     */
    required: number;
    /**
     * @generated from protobuf field: double received = 2;
     */
    received: number;
}
/**
 * @generated from protobuf message core.v1.MemberTaxSummary
 */
export interface MemberTaxSummary {
    /**
     * @generated from protobuf field: string member_uuid = 1;
     */
    memberUuid: string;
    /**
     * @generated from protobuf field: double total_income = 2;
     */
    totalIncome: number;
    /**
     * @generated from protobuf field: double taxable_income = 3;
     */
    taxableIncome: number;
    /**
     * @generated from protobuf field: double federal_tax = 4;
     */
    federalTax: number;
    /**
     * @generated from protobuf field: double provincial_tax = 5;
     */
    provincialTax: number;
    /**
     * @generated from protobuf field: double cpp_contributions = 6;
     */
    cppContributions: number;
    /**
     * @generated from protobuf field: double ei_premiums = 7;
     */
    eiPremiums: number;
    /**
     * @generated from protobuf field: double oas_clawback = 8;
     */
    oasClawback: number;
    /**
     * @generated from protobuf field: double balance_owing = 9;
     */
    balanceOwing: number; // negative = refund
    /**
     * @generated from protobuf field: double rrsp_deduction = 10;
     */
    rrspDeduction: number;
}
/**
 * @generated from protobuf message core.v1.TaxYearDetails
 */
export interface TaxYearDetails {
    /**
     * @generated from protobuf field: int32 tax_year = 1;
     */
    taxYear: number;
    /**
     * @generated from protobuf field: repeated core.v1.MemberTaxSummary members = 2;
     */
    members: MemberTaxSummary[];
}
/**
 * @generated from protobuf message core.v1.ShortfallDetails
 */
export interface ShortfallDetails {
    /**
     * @generated from protobuf field: double shortfall_amount = 1;
     */
    shortfallAmount: number; // cash needed on this date that wasn't there
    /**
     * @generated from protobuf field: double available_funds = 2;
     */
    availableFunds: number; // everything the engine could have drawn on
    /**
     * @generated from protobuf field: double chequing_balance = 3;
     */
    chequingBalance: number;
    /**
     * @generated from protobuf field: double obligations_due = 4;
     */
    obligationsDue: number; // bills and minimum payments due
}
/**
 * Retirement targets, computed by the engine (never in plan-view).
 *
 * @generated from protobuf message core.v1.RetirementDetails
 */
export interface RetirementDetails {
    /**
     * @generated from protobuf field: int32 retirement_age = 1;
     */
    retirementAge: number;
    /**
     * @generated from protobuf field: double target_annual_spending = 2;
     */
    targetAnnualSpending: number; // today's dollars
    /**
     * @generated from protobuf field: double nest_egg_required = 3;
     */
    nestEggRequired: number;
    /**
     * @generated from protobuf field: double projected_nest_egg = 4;
     */
    projectedNestEgg: number; // what the plan has at this date
    /**
     * @generated from protobuf field: repeated core.v1.RetirementDetails.Level levels = 5;
     */
    levels: RetirementDetails_Level[];
}
/**
 * @generated from protobuf message core.v1.RetirementDetails.Level
 */
export interface RetirementDetails_Level {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string; // "security" | "vitality" | "independence"
    /**
     * @generated from protobuf field: double annual_spending = 2;
     */
    annualSpending: number; // today's dollars, after tax
    /**
     * @generated from protobuf field: double nest_egg_required = 3;
     */
    nestEggRequired: number; // at retirement, to sustain this level at the plan's confidence
}
// @generated message type with reflection information, may provide speed optimized methods
class Event$Type extends MessageType<Event> {
    constructor() {
        super("core.v1.Event", [
            { no: 1, name: "date", kind: "message", T: () => Date },
            { no: 2, name: "type", kind: "enum", T: () => ["core.v1.Event.Type", Event_Type, "TYPE_"] },
            { no: 3, name: "importance", kind: "enum", T: () => ["core.v1.Event.Importance", Event_Importance, "IMPORTANCE_"] },
            { no: 4, name: "member_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "entity_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "income", kind: "message", oneof: "details", T: () => IncomeDetails },
            { no: 11, name: "priority_due", kind: "message", oneof: "details", T: () => PriorityDueDetails },
            { no: 12, name: "tax_year", kind: "message", oneof: "details", T: () => TaxYearDetails },
            { no: 13, name: "shortfall", kind: "message", oneof: "details", T: () => ShortfallDetails },
            { no: 14, name: "retirement", kind: "message", oneof: "details", T: () => RetirementDetails }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.Event
 */
export const Event = new Event$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IncomeDetails$Type extends MessageType<IncomeDetails> {
    constructor() {
        super("core.v1.IncomeDetails", [
            { no: 1, name: "source", kind: "enum", T: () => ["core.v1.IncomeDetails.Source", IncomeDetails_Source, "SOURCE_"] },
            { no: 2, name: "gross", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "deductions", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "net", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "destination_account_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "group_rrsp_contribution", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "group_rrsp_employer_match", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.IncomeDetails
 */
export const IncomeDetails = new IncomeDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PriorityDueDetails$Type extends MessageType<PriorityDueDetails> {
    constructor() {
        super("core.v1.PriorityDueDetails", [
            { no: 1, name: "required", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "received", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.PriorityDueDetails
 */
export const PriorityDueDetails = new PriorityDueDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MemberTaxSummary$Type extends MessageType<MemberTaxSummary> {
    constructor() {
        super("core.v1.MemberTaxSummary", [
            { no: 1, name: "member_uuid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "total_income", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "taxable_income", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "federal_tax", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "provincial_tax", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "cpp_contributions", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "ei_premiums", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "oas_clawback", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "balance_owing", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "rrsp_deduction", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.MemberTaxSummary
 */
export const MemberTaxSummary = new MemberTaxSummary$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaxYearDetails$Type extends MessageType<TaxYearDetails> {
    constructor() {
        super("core.v1.TaxYearDetails", [
            { no: 1, name: "tax_year", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "members", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => MemberTaxSummary }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.TaxYearDetails
 */
export const TaxYearDetails = new TaxYearDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ShortfallDetails$Type extends MessageType<ShortfallDetails> {
    constructor() {
        super("core.v1.ShortfallDetails", [
            { no: 1, name: "shortfall_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "available_funds", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "chequing_balance", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "obligations_due", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.ShortfallDetails
 */
export const ShortfallDetails = new ShortfallDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RetirementDetails$Type extends MessageType<RetirementDetails> {
    constructor() {
        super("core.v1.RetirementDetails", [
            { no: 1, name: "retirement_age", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "target_annual_spending", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "nest_egg_required", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "projected_nest_egg", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "levels", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => RetirementDetails_Level }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.RetirementDetails
 */
export const RetirementDetails = new RetirementDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RetirementDetails_Level$Type extends MessageType<RetirementDetails_Level> {
    constructor() {
        super("core.v1.RetirementDetails.Level", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "annual_spending", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "nest_egg_required", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.RetirementDetails.Level
 */
export const RetirementDetails_Level = new RetirementDetails_Level$Type();
